import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../config/firebase";

const citiesCollection = collection(db, "cities");

const cityService = {
  _cache: new Map(), // cache { cityId: cityName }
  getAll: async () => {
    try {
      const citiesSnapshot = await getDocs(citiesCollection);
      const citiesList = citiesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      return citiesList;
    } catch (error) {
      console.error("Error fetching cities:", error);
      throw error;
    }
  },
  add: async (citiesData) => {
    try {
      const docRef = await addDoc(citiesCollection, citiesData);
      return docRef;
    } catch (error) {
      console.error("Error adding city:", error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const cityRef = doc(db, "cities", id);
      await updateDoc(cityRef, data);
    } catch (error) {
      console.error("Error updating city:", error);
      throw error;
    }
  },
  delete: async (cityId) => {
    try {
      await deleteDoc(doc(db, "cities", cityId));
      return true;
    } catch (error) {
      console.error("Error deleting city:", error);
      throw error;
    }
  },

  getNameById: async (cityId) => {
    if (!cityId || typeof cityId !== 'string' || cityId === 'N/A') {
      return null;
    }
    try {
      const cityRef = doc(db, 'cities', cityId);
      const citySnap = await getDoc(cityRef);

      if (citySnap.exists()) {
        return citySnap.data().name;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting city name:', error);
      throw error;
    }
  },

  getIdByName: async (cityName) => {
    try {
      const citiesSnapshot = await getDocs(citiesCollection);
      const citiesList = citiesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const formattedCityName = cityName
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "");

      const city = citiesList.find(
        (city) =>
          city.name.toLowerCase().replace(/\s+/g, "") === formattedCityName
      );
      return city ? city.id : null;
    } catch (error) {
      console.error("Error getting city id:", error);
      throw error;
    }
  },

  getCountryCities: async (countryId) => {
    try {
      const querySnapshot = await getDocs(
        query(citiesCollection, where("country_id", "==", countryId))
      );

      const cities = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return cities;
    } catch (error) {
      console.error("Error getting cities:", error);
      throw error;
    }
  },
};

export default cityService;
